import * as Types from '@trello/graphql/generated';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions =  {"context":{"operationName":"DatePicker"}}
export type DatePickerMutationVariables = Types.Exact<{
  cardId: Types.Scalars['ID'];
  due?: Types.Maybe<Types.Scalars['String']>;
  dueReminder?: Types.Maybe<Types.Scalars['String']>;
  traceId?: Types.Maybe<Types.Scalars['String']>;
}>;


export type DatePickerMutation = (
  { __typename: 'Mutation' }
  & { changeCardDueDate?: Types.Maybe<(
    { __typename: 'Card' }
    & Pick<Types.Card, 'due' | 'dueReminder'>
  )> }
);


export const DatePickerDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DatePicker"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"due"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dueReminder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"traceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeCardDueDate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idCard"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}}},{"kind":"Argument","name":{"kind":"Name","value":"due"},"value":{"kind":"Variable","name":{"kind":"Name","value":"due"}}},{"kind":"Argument","name":{"kind":"Name","value":"dueReminder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dueReminder"}}},{"kind":"Argument","name":{"kind":"Name","value":"traceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"traceId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"due"}},{"kind":"Field","name":{"kind":"Name","value":"dueReminder"}}]}}]}}]};
export type DatePickerMutationFn = Apollo.MutationFunction<DatePickerMutation, DatePickerMutationVariables>;

/**
 * __useDatePickerMutation__
 *
 * To run a mutation, you first call `useDatePickerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDatePickerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [datePickerMutation, { data, loading, error }] = useDatePickerMutation({
 *   variables: {
 *      cardId: // value for 'cardId'
 *      due: // value for 'due'
 *      dueReminder: // value for 'dueReminder'
 *      traceId: // value for 'traceId'
 *   },
 * });
 */
export function useDatePickerMutation(baseOptions?: Apollo.MutationHookOptions<DatePickerMutation, DatePickerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DatePickerMutation, DatePickerMutationVariables>(DatePickerDocument, options);
      }
export type DatePickerMutationHookResult = ReturnType<typeof useDatePickerMutation>;
export type DatePickerMutationResult = Apollo.MutationResult<DatePickerMutation>;
export type DatePickerMutationOptions = Apollo.BaseMutationOptions<DatePickerMutation, DatePickerMutationVariables>;